// export const url = process.env.REACT_APP_API_KEY;
export const url = process.env.REACT_APP_API_HOST || 'https://app.micasastucasa.com/api';
